import type { WhoAmIClient } from '@tebuto/api/clients/models/WhoAmIClient'
import { createContext } from 'react'

export const CurrentClientContext = createContext<WhoAmIClient | null>(null)
